import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api, formatApiError } from "@/lib/auth";
import FileUploader from "@/components/FileUploader";
import { toast } from "sonner";

export default function QuoteRequest() {
  const nav = useNavigate();
  const [form, setForm] = useState({ project_type: "", description: "", dimensions: "", pages: "", usage: "" });
  const [files, setFiles] = useState([]);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/quotes/request", { ...form, file_ids: files.map((f) => f.id) });
      toast.success(`Demande envoyée · ${data.reference}`);
      nav(`/espace/commande/${data.id}`);
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <div className="cs-cream py-16 min-h-[80vh]" data-testid="page-quote">
      <div className="max-w-3xl mx-auto px-6">
        <div className="cs-eyebrow text-neutral-500">Devis sur mesure</div>
        <h1 className="cs-h1 mt-3 text-4xl lg:text-5xl">Décrivez votre projet.</h1>
        <p className="mt-4 text-neutral-700 max-w-xl">Pour les projets complexes ou hors grille tarifaire, Charbonier Studio revient vers vous sous 24 à 48 h ouvrées.</p>
        <form onSubmit={submit} className="mt-10 cs-card p-8 space-y-5">
          <div>
            <label className="cs-eyebrow text-neutral-500">Type de projet</label>
            <input required value={form.project_type} onChange={set("project_type")} className="cs-input mt-2" placeholder="Ex : livre illustré 128 pages" data-testid="quote-type" />
          </div>
          <div>
            <label className="cs-eyebrow text-neutral-500">Description</label>
            <textarea required rows={5} value={form.description} onChange={set("description")} className="cs-input mt-2" placeholder="Contexte, contraintes, ambition" data-testid="quote-desc" />
          </div>
          <div className="grid sm:grid-cols-3 gap-4">
            <div>
              <label className="cs-eyebrow text-neutral-500">Dimensions</label>
              <input value={form.dimensions} onChange={set("dimensions")} className="cs-input mt-2" data-testid="quote-dim" />
            </div>
            <div>
              <label className="cs-eyebrow text-neutral-500">Nb pages</label>
              <input value={form.pages} onChange={set("pages")} className="cs-input mt-2" data-testid="quote-pages" />
            </div>
            <div>
              <label className="cs-eyebrow text-neutral-500">Utilisation</label>
              <input value={form.usage} onChange={set("usage")} className="cs-input mt-2" placeholder="Print, numérique…" data-testid="quote-usage" />
            </div>
          </div>
          <div>
            <label className="cs-eyebrow text-neutral-500">Vos fichiers</label>
            <div className="mt-2"><FileUploader files={files} setFiles={setFiles} testId="quote-uploader" /></div>
          </div>
          <p className="text-[12px] font-mono text-neutral-500 leading-relaxed" data-testid="quote-rgpd">
            Vos informations sont utilisées uniquement pour vous répondre et suivre votre demande —
            aucune prospection. Voir la <a href="/confidentialite" className="cs-link-underline">politique de confidentialité</a>.
          </p>
          <button type="submit" className="cs-btn-primary w-full justify-center" data-testid="quote-submit">
            Envoyer ma demande <ArrowUpRight size={18} />
          </button>
        </form>
      </div>
    </div>
  );
}
